module.exports = __webpack_public_path__ + "img/bb_logo.bc671082.png";